import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, toastSuccess } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getVisitorTypeMasterList_action, deleteVisitorTypeMaster_action } from "../../../../actions/admin_module_action/master_action/visitor_type_master_action";
import Footer from "../../../../common_components/Footer";


class VisitorTypeMasterList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            // exhibitionList: [],
            VisitorTypeMasterList: [],
            // exhibitionID: '',
            VisitorTypeName: '',
            Status: '',
            deleteID: '',
        }

        this.getFillList = this.getFillList.bind(this)
        this.record = this.record.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.deleteVisitorTypeMaster = this.deleteVisitorTypeMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.getVisitorTypeMasterList = this.getVisitorTypeMasterList.bind(this)
    }

    componentDidMount() {
        // this.getFillList(exhibitionActionId, '', '', '', '', '');

        this.getVisitorTypeMasterList()
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === exhibitionActionId) {
                        console.log("country data", data.data)
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            exhibitionList: data.data
                        })

                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    record(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        {/* <th className="text-center">Role ID</th> */}
                        {/* <th className="text-center">From Date</th>
                        <th className="text-center">To Date</th>
                    <th className="text-center">Country</th> */}
                        <th className="text-center" style={{ width: '50px' }}>Sr no.</th>
                        {/* <th >Exhibition Name</th> */}
                        <th className="text-left"> VisitorType Name</th>
                        {/* <th className="text-center">Segment</th> */}
                        <th style={{ width: '60px' }} className="text-center"></th>
                        <th style={{ width: '50px' }} className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {/* <td className="text-center">{data.RoleID}</td> */}
                                    {/* <td className="text-center">{moment(data.ExhibitionDateFrom).format('L')}</td>
                                    <td className="text-center">{moment(data.ExhibitionDateTo).format('L')}</td>
                                <td className="text-center">{this.state.countryList.map(id => (parseInt(id.Code) == data.CountryID ? id.Description : null))}</td> */}
                                    <td className="text-center" style={{ width: '50px' }}>{i + 1}</td>
                                    {/* <td >{data.ExhibitionName}</td> */}
                                    <td className="text-left">{data.VisitorTypeName}</td>
                                    {/* <td className="text-center">{data.segmentArr}</td> */}
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            onClick={(e) => this.handleUpdate(data.VisitorTypeID, data.VisitorTypeName)}
                                        >
                                            Update
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        {/* <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            
                                        >
                                            Delete
                                        </button> */}
                                        <i class="fa fa-trash-o text-danger"  onClick={(e) => this.onDelete(data.VisitorTypeID)}></i>
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    getVisitorTypeMasterList() {
        this.setState({ isLoading: true })
        const { VisitorTypeName, Status } = this.state
        this.props.getVisitorTypeMasterList_action(VisitorTypeName, Status)
            .then((data) => {
                if (data.error != 1) {
                    // var doneID = []
                    // for (var i = 0; i < data.data[1].length; i++) {
                    //     var segmentArr = []
                    //     if (!doneID.includes(data.data[1][i].VisitorTypeId)) {
                    //         for (var j = 0; j < data.data[1].length; j++) {
                    //             if (data.data[1][i].VisitorTypeId == data.data[1][j].VisitorTypeId) {
                    //                 segmentArr.push(data.data[1][j].ChapterName)
                    //             }
                    //         }
                    //         for (var j = 0; j < data.data[0].length; j++) {
                    //             if (data.data[1][i].VisitorTypeId == data.data[0][j].VisitorTypeId) {
                    //                 data.data[0][j].segmentArr = segmentArr.toString()
                    //             }
                    //         }
                    //         doneID.push(data.data[1][i].VisitorTypeId)
                    //     }
                    // }
                    // console.log(data.data[0])

                    this.setState({ VisitorTypeMasterList: data.data[0] })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { VisitorTypeName, Status } = this.state
        this.setState({
            VisitorTypeName: '',
            Status: ''
        })
        setTimeout(() => {
            this.getVisitorTypeMasterList()
        }, 100);
    }

    handleAdd() {
        this.props.navigate('/visitorTypeMasterAU', { state: { is_add: true, } })
    }

    handleUpdate(id, VisitorTypeName) {
        this.props.navigate('/visitorTypeMasterAU', { state: { is_update: true, VisitorTypeID: id, VisitorTypeName:VisitorTypeName} })
    }

    deleteVisitorTypeMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteVisitorTypeMaster_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getVisitorTypeMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(i) {
        const { } = this.state
        this.setState({ deleteID: i })
        this.setState({ isOpen: true, })
    }

    updateItem(item) {
        const { VisitorTypeMasterList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = VisitorTypeMasterList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(VisitorTypeMasterList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }


    render() {
        const { isOpen, isLoading, Status, exhibitionID, currentPage, VisitorTypeMasterList, exhibitionList, VisitorTypeName } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = VisitorTypeMasterList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(VisitorTypeMasterList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">

                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">VisitorType List</h6>
                            </div>
                        </div>
                        {/* <div className="app-content with-dr-container com-height"> */}
                        <div className="admin-top-space p-2">
                                {
                                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                    <div className="row m-0">
                                        <div className="col-md-3">
                                            <label>VisitorType Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={VisitorTypeName}
                                                onChange={(e) => this.setState({ VisitorTypeName: e.target.value, })}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Status</label>
                                            <select className="form-control"
                                                value={Status}
                                                onChange={(e) => this.setState({ Status: e.target.value })}  >
                                                <option value={''}>Select</option>
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                        </div>
                                         <div className="col-md-6">
                                            <label></label>
                                    {
                                        JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                        <div
                                            className="mb-1"
                                            role="group"
                                            aria-label="Basic example"
                                            style={{ float: "right" }}
                                        >
                                            <button type="button" className="btn btn-aqua"
                                                onClick={e => this.getVisitorTypeMasterList()}
                                            >
                                                Search
                                            </button>
                                            <button type="button" className="btn btn-aqua mx-2"
                                                onClick={e => this.handleAdd()}
                                            >
                                                Add
                                            </button>
                                            <button type="button" className="btn btn-gray"
                                                onClick={e => this.clearSearch()}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    }
                                </div>
                                        {/* <div class="">
                                    <label for="validationCustom03">Total Exhibition Area<span style={{ color: 'red' }}>*</span></label>
                                    <input value={totalExhibitionArea} onChange={(e) => this.setState({ totalExhibitionArea: parseInt(e.target.value) })} type="number" class="form-control" placeholder="" />
                                </div> */}
                                    </div>
                                }
                          <div className="row m-0 mx-2">
                            <div className="table-responsive  px-1 sticky-table-wrapper mt-3">
                                {this.record(currentRecords)}
                            </div>
                            <div className="mt-2 float-left trp px-1">
                                {
                                    VisitorTypeMasterList.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></>
                                }
                                <div className="table-record-pages">
                                    <p>{`${currentPage} of ${nPages} pages`}</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteVisitorTypeMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getVisitorTypeMasterList_action, deleteVisitorTypeMaster_action })(VisitorTypeMasterList));